/* ==========================================================================
   Accessibility hardening JS — WCAG 2.2 AA
   --------------------------------------------------------------------------
   Off-canvas drawers (.Drawer) are visibility:hidden when closed, but because
   they keep layout (display:block, translated off-screen) some still tripped
   axe's aria-hidden-focus rule. Sync the `inert` attribute with `aria-hidden`
   so a closed drawer is unambiguously removed from the tab order and the
   accessibility tree. The theme's drawer _open handler does NOT auto-focus, so
   there is no race with inert being cleared on open.

   Deliberately NOT applied to #wd-product-modal: its closed-state
   visibility:hidden already satisfies axe, and its open handler calls
   modalEl.focus() synchronously — adding inert there would block that focus.
   Added 2026-06-30 with the storefront accessibility pass.
   ========================================================================== */
(function () {
  function syncInert(el) {
    if (el.getAttribute('aria-hidden') === 'true') {
      el.setAttribute('inert', '');
    } else {
      el.removeAttribute('inert');
    }
  }

  function init() {
    document.querySelectorAll('.Drawer').forEach(function (el) {
      syncInert(el);
      new MutationObserver(function () { syncInert(el); })
        .observe(el, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
